// covered-by: frontends/carrie/src/routes/ask-puntt/__tests__/launcherSearch.test.ts
//
// Search params for ask-puntt list launchers (/projects, /chats).
//
// URL contract:
//   ?q=<text>           — filter query
//   ?view=grid|list     — layout mode
import { z } from "zod";

export type LauncherView = "grid" | "list";

export type LauncherSearch = {
  q?: string;
  view?: LauncherView;
};

export type LauncherSearchInput = Partial<LauncherSearch>;

const launcherViewSchema = z.enum(["grid", "list"]);

/** Raw search record from TanStack validateSearch. */
export function parseLauncherSearch(
  search: Record<string, unknown>,
): LauncherSearch {
  const qRaw = typeof search.q === "string" ? search.q : "";
  const q = qRaw.trim().length > 0 ? qRaw.trim() : undefined;

  const viewRaw = search.view;
  const view =
    typeof viewRaw === "string" && launcherViewSchema.safeParse(viewRaw).success
      ? (viewRaw as LauncherView)
      : undefined;

  return { q, view };
}

/** Search params for launcher route navigations. */
export function launcherSearch(input?: LauncherSearchInput): LauncherSearch {
  const raw = input ?? {};
  const q = raw.q?.trim() ? raw.q.trim() : undefined;
  const view =
    raw.view === "grid" || raw.view === "list" ? raw.view : undefined;
  return { q, view };
}
